import { Dropdown } from "primereact/dropdown"

const BaseDropdown = (props)=>{
    return <Dropdown {...props}></Dropdown>
}

export default BaseDropdown;